import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpcomingTeamsComponent } from './upcoming-teams/upcoming-teams.component';
import { SharedModule } from '../shared/shared.module';
import { UpcomingTeamsBarChartComponent } from './upcoming-teams/upcoming-teams-bar-chart/upcoming-teams-bar-chart.component';
import { RouterModule } from '@angular/router';
import { RecentAcceptsComponent } from './recent-accepts/recent-accepts.component';
import { RecentAcceptsItemComponent } from './recent-accepts/recent-accepts-item/recent-accepts-item.component';
import { RecentFormResponsesComponent } from './recent-form-responses/recent-form-responses.component';

@NgModule({
  declarations: [
    UpcomingTeamsComponent,
    UpcomingTeamsBarChartComponent,
    RecentAcceptsComponent,
    RecentAcceptsItemComponent,
    RecentFormResponsesComponent,
  ],
  imports: [CommonModule, SharedModule, RouterModule],
  exports: [UpcomingTeamsComponent, RecentAcceptsComponent, RecentFormResponsesComponent],
})
export class WidgetsModule {}
